module.exports = __webpack_public_path__ + "img/payment-successful.644ad9f2.png";